import { createSelector } from 'reselect'

const maintenanceEnabledSelector = (state) => {
  return (
    (state.feature_flags && state.feature_flags.maintenance_enabled) || false
  )
}

export const selectMaintenanceEnabled = createSelector(
  [maintenanceEnabledSelector],
  (maintenance_enabled) => {
    return {
      maintenance_enabled,
    }
  },
)
